import { render, staticRenderFns } from "./TransitionSlide.vue?vue&type=template&id=355d8950&scoped=true&lang=pug&"
import script from "./TransitionSlide.vue?vue&type=script&lang=ts&"
export * from "./TransitionSlide.vue?vue&type=script&lang=ts&"
import style0 from "./TransitionSlide.vue?vue&type=style&index=0&id=355d8950&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355d8950",
  null
  
)

export default component.exports